import React from 'react';
import PropTypes from 'prop-types';
import '../App.css';

export default function DexSelector({ options, value, onChange }) {
  return (
    <>
      <style>{`
        .fl-dex-select {
          background: rgba(14,17,23,0.7);
          border: 1px solid rgba(200,168,75,0.2);
          border-radius: 6px;
          color: #e8e0d0;
          font-family: 'Georgia', serif;
          font-size: 0.82rem;
          padding: 0.45rem 2rem 0.45rem 0.85rem;
          outline: none;
          cursor: pointer;
          letter-spacing: 0.04em;
          transition: border-color 0.2s, background 0.2s;
          appearance: none;
          -webkit-appearance: none;
        }
        .fl-dex-select:focus, .fl-dex-select:hover {
          border-color: rgba(200,168,75,0.5);
          background: rgba(26,35,64,0.8);
        }
        .fl-dex-select option {
          background: #0e1117;
          color: #e8e0d0;
        }
        .fl-dex-label {
          font-family: 'Georgia', serif;
          font-size: 0.72rem;
          font-weight: 700;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #ffffff;
        }
      `}</style>

      <div style={S.wrap}>
        <label className="fl-dex-label" htmlFor="dex">Pokédex</label>
        <div style={S.selectWrap}>
          <select
            id="dex"
            className="fl-dex-select"
            value={value}
            onChange={e => onChange(e.target.value)}
          >
            {options.map(d => (
              <option key={d.id} value={d.id}>{d.name}</option>
            ))}
          </select>
          {/* Custom chevron */}
          <span style={S.chevron}>▾</span>
        </div>
      </div>
    </>
  );
}

const S = {
  wrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  selectWrap: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
  },
  chevron: {
    position: 'absolute',
    right: '0.6rem',
    color: '#40382e',
    fontSize: '0.75rem',
    pointerEvents: 'none',
    lineHeight: 1,
  },
};

DexSelector.propTypes = {
  options: PropTypes.array.isRequired,
  value:   PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};